import { toggleSeriesBookmark } from "@/actions/bookmarks/toggle-series-bookmark";
import { toggleShopProductBookmark } from "@/actions/bookmarks/toggle-shop-product-bookmark";
import { useSession } from "@/lib/auth/client";
import useSWR from "swr";

const fetcher = (url: string) => fetch(url).then((r) => r.json());

export function useSeriesBookmarks() {
    const { data: session } = useSession();
    const { data, mutate } = useSWR<{ SerieId: number | null }[]>(
        session?.user?.id ? "/api/series/bookmark" : null,
        fetcher,
    );
    const bookmarks = data ?? [];
    return {
        bookmarks,
        isBooked: (seriesId: number) =>
            bookmarks.some((b) => b.SerieId === seriesId),
        setBookmarks: mutate,
        toggleBookmark: async (seriesId: number) => {
            const result = await toggleSeriesBookmark(seriesId);
            if (!result.success) return;
            await mutate(result.data, { revalidate: false });
        },
    };
}

export function useShopProductBookmarks() {
    const { data: session } = useSession();
    const { data, mutate } = useSWR<{ TyProductId: string | null }[]>(
        session?.user?.id ? "/api/shop-products/bookmark" : null,
        fetcher,
    );
    const bookmarks = data ?? [];

    return {
        bookmarks,
        isBooked: (tyProductId: string) =>
            bookmarks.some((b) => b.TyProductId === tyProductId),
        setBookmarks: mutate,
        toggleBookmark: async (tyProductId: string) => {
            const result = await toggleShopProductBookmark(tyProductId);
            if (!result.success) return;
            await mutate(result.data, { revalidate: false });
        },
    };
}
